import { Divider } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useBrandingAndTheme } from '../../../utilities/hooks';
import { ProgressMeterTypeSection } from './ProgressMeterTypeSection';
import { QuestionNumberingSection } from './QuestionNumberingSection';
import { SurveyLogoSection } from './SurveyLogoSection';
import { SurveyThemeSection } from './SurveyThemeSection';

type BrandingAndThemeProps = { disabled?: boolean };

export const BrandingAndTheme = ({ disabled }: BrandingAndThemeProps) => {
	const {
		surveyImage,
		surveyImageValidationResult,
		surveyLogoFile,
		showKincentricLogo,
		surveyTheme,
		themes,
		surveyThemeValidationResult,
		progressMeterType,
		shouldShowQuestionNumbering,
		handleSurveyLogoDisplayNameChange,
		handleSurveyLogoPlacementChange,
		handleSurveyLogoFileChange,
		handleRemoveSurveyLogo,
		handleShowKincentricLogoChange,
		handleThemeChange,
		handleSurveyThemeValueChange,
		handleSurveyProgressMeterTypeChange,
		handleShowQuestionNumberingChange,
	} = useBrandingAndTheme();

	return (
		<>
			<SurveyLogoSection
				disabled={disabled}
				surveyImage={surveyImage}
				file={surveyLogoFile}
				showKincentricLogo={showKincentricLogo}
				onDisplayNameChange={handleSurveyLogoDisplayNameChange}
				onPlacementChange={handleSurveyLogoPlacementChange}
				onLogoChange={handleSurveyLogoFileChange}
				onLogoRemoved={handleRemoveSurveyLogo}
				onShowKincentricLogoChange={handleShowKincentricLogoChange}
				validationResult={surveyImageValidationResult}
			/>
			<Divider type='dashed' />
			<SurveyThemeSection
				disabled={disabled}
				themes={themes}
				surveyTheme={surveyTheme}
				validationResult={surveyThemeValidationResult}
				onThemeChange={handleThemeChange}
				onThemeValueChange={handleSurveyThemeValueChange}
			/>
			<Divider type='dashed' />
			<ProgressMeterTypeSection disabled={disabled} progressMeterType={progressMeterType} onChange={handleSurveyProgressMeterTypeChange} />
			<Divider type='dashed' />
			<QuestionNumberingSection
				disabled={disabled}
				shouldShowQuestionNumbering={shouldShowQuestionNumbering}
				onChange={handleShowQuestionNumberingChange}
			/>
		</>
	);
};
